<template>
    <div id="contenedor-deducciones-main">
      <router-view />
    </div>
</template>

<script>
export default {
  name: 'DeduccionesMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
